import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

// intercepting to capture errors
axios.interceptors.response.use(
    function (response) {
        return response.data ? response.data : response;
    },
    function (error) {
        let message;
        const status = error.response ? error.response.status : null;

        switch (status) {
            case 500:
                message = "Internal Server Error";
                break;
            case 401:
                // logoutUser();
                message = "Invalid credentials";
                break;
            case 404:
                message = "Sorry! The data you are looking for could not be found";
                break;
            default:
                message = error.message || "Something went wrong";
        }
        return Promise.reject(message);
    }
);

class APIClient {
    get = (url: any, params: any) => {
        let response;

        let paramKeys: any = [];

        if (params) {
            Object.keys(params).map(key => {
                paramKeys.push(key + '=' + params[key]);
                return paramKeys;
            });

            const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
            response = axios.get(`${url}?${queryString}`, params);
        } else {
            response = axios.get(`${url}`, params);
        }

        return response;
    };

    getData = (url: any, data: any) => {
        console.log(url)
        return axios.get(url, data);
    }
    getDataSearch = (url: any, data: any) => {
        const newUrl = `${url}?page=${data.page}&size=${data.size}&param=${encodeURIComponent(data.search)}`;
        return axios.get(newUrl);
    }

    getProduct = (url: any, pagination: any, data: any) => {
        return axios.post(`${url}?page=${pagination.page}&size=${pagination.size}`, data);
    }
    getNews = (url: any, pagination: any, data: any) => {
        return axios.post(`${url}?page=${pagination.page}&size=${pagination.size}`, data);
    }

    getProductById = (url: any, id: any) => {
        const newUrl = `${url}/${id}`;
        return axios.get(newUrl);
    }
    getNewsById = (url: any, id: any) => {
        const newUrl = `${url}/${id}`;
        return axios.get(newUrl);
    }

    create = (url: any, data: any) => {
        return axios.post(url, data);
    };

    updateByID = (url: any, data: any) => {
        let headers: { [key: string]: string } = {};
        if (data instanceof FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        return axios.post(url, data, {headers})
    }

    updateColor = (url: any, data: any) => {
        console.log(url, data)
        return axios.post(url, data);
    }

    deleteById = (url: any, id: any) => {
        console.log("delete")
        return axios.post(url + "/" + id)
    }
    // create Product

    createProduct = (url: any, data: any) => {
        let headers: { [key: string]: string } = {};
        if (data instanceof FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        return axios.post(url, data, {headers});
    };

    createCategory = (url: any, data: any) => {
        let headers: { [key: string]: string } = {};
        if (data instanceof FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        return axios.post(url, data, {headers});
    };

    adminLogin = (url: any, data: any) => {
        console.log(url, data);
        return axios.post(url, data);
    }
    /**
     * Updates data
     */
    update = (url: any, data: any) => {
        return axios.patch(url, data);
    };

    put = (url: any, data: any) => {
        return axios.put(url, data);
    };
    /**
     * Delete
     */
    delete = (url: any, config: any) => {
        return axios.delete(url, {...config});
    };
}

const getLoggedInUser = () => {

    const user = localStorage.getItem("authUser");
    if (!user) {
        return null;
    } else {
        return JSON.parse(user);
    }
};

const logoutUser = () => {
    localStorage.removeItem("authUser");
    window.location.href = "/login";
}


export {APIClient, getLoggedInUser};